import { ResizeStackedCTA } from '@tvg/fuse-utils';
import styled from 'styled-components';
import { BrandLogos } from '../../fuse-brand-logos/src/brand-logos';
import { Picture } from '../../fuse-picture/src/picture';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';

const StyledContentPattern = styled.div
	.withConfig({
		shouldForwardProp: (prop) => !['imageAlignment', 'imagePosition'].includes(prop),
	})
	.attrs({
		className: 'fuse-content-pattern',
	})`
        ${({ imageAlignment, imagePosition }) => `

            width: 100%;

            @media screen and (min-width: ${gridConfig.m.minWidth}) {
                align-items: ${imageAlignment === 'center' ? 'center' : 'start'};
                display: flex;
                flex-flow: ${imagePosition === 'right' ? 'row-reverse' : 'row'};
        `}
`;

const StyledContentWrapper = styled.div.attrs({
	className: 'fuse-content-pattern__content-wrapper',
	'data-testid': 'fuse-content-pattern-content-wrapper-test-id',
})`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-global-space6);
	padding: var(--spacing-global-space6) var(--spacing-global-space5);
	width: 100%;

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		flex: 1 1 60%;
		gap: var(--spacing-global-space7);
		padding: var(--spacing-global-space7);
	}

	@media screen and (min-width: ${gridConfig.l.minWidth}) {
		flex: 1 1 60%;
		gap: var(--spacing-global-space8);
		padding: var(--spacing-global-space8) var(--spacing-global-space9);
	}
`;

const StyledContentBody = styled.div.attrs({
	className: 'fuse-content-pattern__content-body',
	'data-testid': 'fuse-content-pattern-content-body-test-id',
})``;

const StyledContentCTA = styled.div.attrs({
	className: 'fuse-content-pattern__content-cta',
	'data-testid': 'fuse-content-pattern-content-cta-test-id',
})`
	display: flex;
	flex-wrap: wrap;
	gap: var(--spacing-global-space6);

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		width: auto;
	}
`;

const StyledResizeStackedCTA = styled(ResizeStackedCTA).attrs({
	className: 'fuse-content-pattern__resized-content-cta',
	'data-testid': 'fuse-content-pattern-resized-content-cta-test-id',
})``;

const StyledImageWrapper = styled.div
	.withConfig({
		shouldForwardProp: (prop) => !['imageRatio', 'isPicture'].includes(prop),
	})
	.attrs({
		className: 'fuse-content-pattern__image-wrapper',
		'data-testid': 'fuse-content-pattern-image-wrapper-test-id',
	})`
		${({ imageRatio, isPicture }) => `

			width: 100%;

			${
	isPicture
		? ``
		: `
				align-items: center;
				aspect-ratio: ${imageRatio ? imageRatio.replace(':', '/') : 'unset'};
				display: flex;
				justify-content: center;
				object-fit: cover;
			`
}

			@media screen and (min-width: ${gridConfig.m.minWidth}) {
				flex: 1 1 40%;
			}
		`}
`;

const StyledPicture = styled(Picture)
	.withConfig({
		shouldForwardProp: (prop) => !['imageRatio'].includes(prop),
	})
	.attrs({
		className: 'fuse-content-pattern__picture',
		'data-testid': 'fuse-content-pattern-picture-test-id',
	})`
		display: flex;
		margin: 0;

		& .fuse-picture__img {
			aspect-ratio: ${({ imageRatio }) => (imageRatio ? imageRatio.replace(':', '/') : 'unset')};
			object-fit: cover;
			width: 100%;
		}
`;

const StyledBrandLogos = styled(BrandLogos).attrs({
	className: 'fuse-content-pattern__brand-logo',
	'data-testid': 'fuse-content-pattern-brand-logo-test-id',
	width: '50%',
})``;

const StyledIconWrapper = styled.div.attrs({
	className: 'fuse-content-pattern__icon-wrapper',
	'data-testid': 'fuse-content-pattern-icon-wrapper-test-id',
})`
	flex-basis: 50%;
`;

const StyledVideoWrapper = styled.div.attrs({
	className: 'fuse-content-pattern__video-wrapper',
	'data-testid': 'fuse-content-pattern-video-wrapper-test-id',
})`
	width: 100%;

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		flex: 1 1 40%;
	}
`;

export {
	StyledBrandLogos,
	StyledContentBody,
	StyledContentCTA,
	StyledContentPattern,
	StyledContentWrapper,
	StyledIconWrapper,
	StyledImageWrapper,
	StyledPicture,
	StyledResizeStackedCTA,
	StyledVideoWrapper,
};
